import O from "./_common.js";
import P from "../../_styles/common/light.js";
import { changeColor as n } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function B(p) {
  const {
    textColor2: o,
    textColor3: g,
    textColorDisabled: t,
    primaryColor: i,
    primaryColorHover: d,
    inputColor: r,
    inputColorDisabled: x,
    borderColor: a,
    warningColor: e,
    warningColorHover: s,
    errorColor: l,
    errorColorHover: c,
    borderRadius: b,
    lineHeight: C,
    fontSizeTiny: u,
    fontSizeSmall: h,
    fontSizeMedium: m,
    fontSizeLarge: $,
    heightTiny: f,
    heightSmall: H,
    heightMedium: S,
    heightLarge: F,
    actionColor: v,
    clearColor: D,
    clearColorHover: L,
    clearColorPressed: W,
    placeholderColor: E,
    placeholderColorDisabled: T,
    iconColor: w,
    iconColorDisabled: z,
    iconColorHover: y,
    iconColorPressed: j,
    fontWeight: M
  } = p;
  return Object.assign(Object.assign({}, O), {
    fontWeight: M,
    countTextColorDisabled: t,
    countTextColor: g,
    heightTiny: f,
    heightSmall: H,
    heightMedium: S,
    heightLarge: F,
    fontSizeTiny: u,
    fontSizeSmall: h,
    fontSizeMedium: m,
    fontSizeLarge: $,
    lineHeight: C,
    lineHeightTextarea: C,
    borderRadius: b,
    iconSize: "16px",
    groupLabelColor: v,
    groupLabelTextColor: o,
    textColor: o,
    textColorDisabled: t,
    textDecorationColor: o,
    caretColor: i,
    placeholderColor: E,
    placeholderColorDisabled: T,
    color: r,
    colorDisabled: x,
    colorFocus: r,
    groupLabelBorder: `1px solid ${a}`,
    border: `1px solid ${a}`,
    borderHover: `1px solid ${d}`,
    borderDisabled: `1px solid ${a}`,
    borderFocus: `1px solid ${d}`,
    boxShadowFocus: `0 0 0 2px ${n(i, {
      alpha: 0.2
    })}`,
    loadingColor: i,
    // warning
    loadingColorWarning: e,
    borderWarning: `1px solid ${e}`,
    borderHoverWarning: `1px solid ${s}`,
    colorFocusWarning: r,
    borderFocusWarning: `1px solid ${s}`,
    boxShadowFocusWarning: `0 0 0 2px ${n(e, {
      alpha: 0.2
    })}`,
    caretColorWarning: e,
    // error
    loadingColorError: l,
    borderError: `1px solid ${l}`,
    borderHoverError: `1px solid ${c}`,
    colorFocusError: r,
    borderFocusError: `1px solid ${c}`,
    boxShadowFocusError: `0 0 0 2px ${n(l, {
      alpha: 0.2
    })}`,
    caretColorError: l,
    clearColor: D,
    clearColorHover: L,
    clearColorPressed: W,
    iconColor: w,
    iconColorDisabled: z,
    iconColorHover: y,
    iconColorPressed: j,
    suffixTextColor: o
  });
}
const I = {
  name: "Input",
  common: P,
  self: B
}, q = I;
export {
  q as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input/styles/light.js
// module id = 217
// module chunks = 67